exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "signin h2{margin:20px 0}signin button{margin:10px 0!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./frontend/components/auth/signin/signin.styl
 ** module id = 223
 ** module chunks = 0
 **/